module.exports = __webpack_public_path__ + "img/breakfast-dinner-icon.185a0396.svg";